import * as React from "react"
import {useEffect} from "react"
import {object, string} from "yup";
import {CascaderAjaxSeeker} from "@ui-seeker/core";
import {useValidatorSeeker} from "@ui-seeker/app";

import {BACKEND_APIS} from "@constants";
import {useMatchersSkusForm} from "../../@hooks";
import {matcherSKUDrawerError} from "../../@signals";


export default function MatchersSKUsDrawerCategory() {
	const { localValue, handleChange } = useMatchersSkusForm('categoryID')
	const { errors } = useValidatorSeeker({
		categoryID: localValue
	}, object({
		categoryID: string().required('Category is mandatory')
	}))

	useEffect(() => {
		matcherSKUDrawerError.value = {
			...matcherSKUDrawerError.value,
			categoryID: errors?.categoryID
		}
	}, [errors?.categoryID]);

    return <CascaderAjaxSeeker
		isMultiple={false}
		menuWidth={160}
		urlAjax={`${BACKEND_APIS.UNMATCHED}/new-products/category-tree`}
        label="Category SKU"
        placeholder="Please select a category for the SKU"
		value={localValue || ''}
		onChange={newValue => handleChange(newValue)}
		error={errors?.categoryID}
	/>
}